import {ReservationSearch} from "components/front/PMS/Reservation/Search/ReservationSearch"
import React from "react"

export const ReservationSearchRoute = () => {

  return <div className="container">
    <ReservationSearch />
  </div>
}